import { render } from "./RegistredMaterials.vue?vue&type=template&id=33c51038&scoped=true&ts=true"
import script from "./RegistredMaterials.vue?vue&type=script&lang=ts"
export * from "./RegistredMaterials.vue?vue&type=script&lang=ts"

import "./RegistredMaterials.vue?vue&type=style&index=0&id=33c51038&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c51038"]])

export default __exports__